import { createActions, using } from "redux-box";

export default createActions({
  requestPlatformList: using("page"),
  requestConcatPlatformList: using("page"),
  createPlatform: using("data"),
  updatePlatform: using("data"),
  setActivePlatform: using("platform"),
  setPlatformEditMode: using("value"),
  setPlatformError: using("value"),
  clearPlatformFormState: using(),
  requestContentPolicySchema: using(),
});
